import { zUid } from "src/types/zUid";
import z from "zod";

export const zBom3PosSettings = z.object({
  ver: z.literal("1"),
  columnsOrder: z.string().array().optional(),
  invisibleColumns: zUid.array().optional(),
  columnWidths: z.record(z.string(), z.number().or(z.string())).optional(),
  fixedColumns: z.number().optional(),
});

export type ZBom3PosSettings = z.infer<typeof zBom3PosSettings>;

// В случае изменения формата, нужно будет переделать zBom3PosSettings в z.discriminatedUnion
